var _circle, _path, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXprt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0755 15.7225H9.40881V13.794H12.0755C12.4876 13.794 12.823 13.717 13.0818 13.5632C13.3405 13.4038 13.5298 13.1841 13.6496 12.9038C13.7694 12.6236 13.8293 12.3077 13.8293 11.956C13.8293 11.5989 13.7694 11.2665 13.6496 10.9588C13.5298 10.6511 13.3405 10.4038 13.0818 10.217C12.823 10.0302 12.4876 9.93681 12.0755 9.93681H10.1563V19H8V8H12.0755C12.8949 8 13.5969 8.17033 14.1815 8.51099C14.7709 8.84615 15.2213 9.31044 15.5328 9.90385C15.8443 10.4973 16 11.1758 16 11.9396C16 12.7143 15.8443 13.3846 15.5328 13.9505C15.2213 14.5165 14.7709 14.9533 14.1815 15.261C13.5969 15.5687 12.8949 15.7225 12.0755 15.7225Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 5,
    width: 8,
    height: 1.5,
    fill: "#DA1E27"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXprt);
export default __webpack_public_path__ + "static/media/xprt.9edd323a990b3e105d1dd55a0469be50.svg";
export { ForwardRef as ReactComponent };